/**
 * priorTests.js — catalog 3.8 prior-test records (s107, Dr. Rami 2026-10-16; copy in
 * claude/ORELLA_PRIOR_TEST_RECORDS_COPY_v1.md). THE ONE OWNER of "did the patient say they had a test,
 * and which records should Detect ask for". No imports, so the node gate can load it.
 *
 *   question.priorTest   { mode: 'one'|'each', triggers: [...English options], record?: '<English label>' }
 *   focusArea.priorTestArea  '<English label>'  (an area that exists because of a test result)
 *
 * ★ Answers are the case's flat answer map ('<category>_<id>' → [English option] | string).
 * ★ A row's `key` is stable across visits (the area row, the question, or question + option), so an
 *   upload tagged with it (document.priorRecord) marks that row Added on every later visit.
 * ★ Labels come back in ENGLISH; the screen translates them (tq for a record, to for an option).
 */

const asList = (v) => (Array.isArray(v) ? v : typeof v === 'string' && v ? [v] : [])

/** The trigger options the patient picked for this question ([] when none / untagged). */
export function priorTestPicks(question, answer) {
  const tag = question && question.priorTest
  if (!tag || !Array.isArray(tag.triggers)) return []
  return asList(answer).filter((a) => tag.triggers.includes(a))
}

/** True when this answer means "had it" — the intake shows the keep-a-copy note under it. */
export const priorTestTriggered = (question, answer) => priorTestPicks(question, answer).length > 0

/**
 * The pinned Detect rows for a case, in catalog order: the area row first, then each tagged question.
 * Each row: { key, label, kind: 'record'|'option' }  (kind says which translator the screen uses).
 * Duplicate labels collapse to the first row (two questions asking about the same PSA → one row).
 */
export function priorRecordRows(focusArea, answers) {
  const rows = []
  const seen = new Set()
  const add = (row) => {
    const k = row.kind + ':' + row.label
    if (seen.has(k)) return
    seen.add(k)
    rows.push(row)
  }
  if (!focusArea) return rows
  if (focusArea.priorTestArea) add({ key: 'area', label: focusArea.priorTestArea, kind: 'record' })
  const cats = focusArea.questions || {}
  for (const cat of Object.keys(cats)) {
    for (const q of cats[cat] || []) {
      const picks = priorTestPicks(q, answers && answers[cat + '_' + q.id])
      if (!picks.length) continue
      if (q.priorTest.mode === 'each') {
        for (const p of picks) add({ key: cat + '_' + q.id + ':' + p, label: p, kind: 'option' })
      } else {
        add({ key: cat + '_' + q.id, label: q.priorTest.record || q.text, kind: 'record' })
      }
    }
  }
  return rows
}

/** The row keys some saved upload was attached through (document.priorRecord). */
export function addedRecordKeys(documents) {
  return new Set((Array.isArray(documents) ? documents : []).map((d) => d && d.priorRecord).filter(Boolean))
}
